export interface Comic {
  id: string;
  title: string;
  author: string;
  cover: string;
  category: string;
  status: string;
  description: string;
  rating: number;
  views: number;
  chapters: number;
  updatedAt: string;
  tags: string[];
}

export interface Category {
  slug: string;
  name: string;
  icon: string;
  description: string;
}

export const categories: Category[] = [
  { slug: 'rexue', name: '热血', icon: 'ri-fire-line', description: '激情燃烧的冒险故事，感受战斗的快感' },
  { slug: 'lianai', name: '恋爱', icon: 'ri-heart-line', description: '甜蜜浪漫的爱情故事，心动每一刻' },
  { slug: 'xuanyi', name: '悬疑', icon: 'ri-search-line', description: '扣人心弦的推理谜题，挑战你的智商' },
  { slug: 'gaoxiao', name: '搞笑', icon: 'ri-emotion-laugh-line', description: '欢乐无限的搞笑日常，笑到停不下来' },
  { slug: 'qihuan', name: '奇幻', icon: 'ri-magic-line', description: '天马行空的奇幻世界，想象力无边界' },
  { slug: 'kehuan', name: '科幻', icon: 'ri-rocket-line', description: '未来科技的科幻史诗，探索未知领域' },
  { slug: 'gufeng', name: '古风', icon: 'ri-ancient-gate-line', description: '唯美典雅的古典故事，沉浸千年风华' },
  { slug: 'dushi', name: '都市', icon: 'ri-building-line', description: '现代都市的精彩故事，贴近你的生活' },
];

export const comics: Comic[] = [
  {
    id: 'doupo-cangqiong',
    title: '斗破苍穹',
    author: '天蚕土豆',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20style%20young%20warrior%20in%20martial%20arts%20fantasy%20world%20holding%20a%20flaming%20sword%2C%20determined%20expression%2C%20dynamic%20pose%2C%20anime%20style%20cover%20art%20with%20dramatic%20lighting%20and%20epic%20atmosphere%2C%20vibrant%20orange%20and%20red%20color%20scheme&width=600&height=800&seq=comic-cover-01&orientation=portrait',
    category: '热血',
    status: '连载中',
    description: '天才少年萧炎在创造了家族空前绝后的修炼纪录后突然成了废人，种种打击接踵而至。就在他即将绝望之时，一缕幽魂从他手上的戒指里浮现，一扇全新的大门就此开启！',
    rating: 9.5,
    views: 12500000,
    chapters: 568,
    updatedAt: '2026-08-06',
    tags: ['玄幻', '热血', '战斗'],
  },
  {
    id: 'yi-ren-zhi-xia',
    title: '一人之下',
    author: '米二',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20style%20college%20student%20with%20supernatural%20powers%20surrounded%20by%20mystical%20energy%2C%20modern%20urban%20fantasy%20setting%2C%20anime%20art%20style%20with%20traditional%20Taoist%20elements%2C%20cool%20and%20mysterious%20atmosphere&width=600&height=800&seq=comic-cover-02&orientation=portrait',
    category: '悬疑',
    status: '连载中',
    description: '随着爷爷尸体被盗、神秘少女冯宝宝的造访，少年张楚岚的平静校园生活被彻底颠覆。急于解开爷爷和自身秘密的张楚岚，开始了一段充满冒险的异人江湖之旅。',
    rating: 9.6,
    views: 9800000,
    chapters: 612,
    updatedAt: '2026-08-06',
    tags: ['奇幻', '悬疑', '现代'],
  },
  {
    id: 'huyao-xiaohongniang',
    title: '狐妖小红娘',
    author: '小新',
    cover: 'https://readdy.ai/api/search-image?query=Beautiful%20fox%20spirit%20girl%20with%20long%20flowing%20hair%20in%20traditional%20Chinese%20red%20dress%2C%20romantic%20fantasy%20atmosphere%20with%20cherry%20blossoms%2C%20anime%20style%20illustration%20with%20soft%20pink%20and%20red%20color%20palette%2C%20elegant%20and%20dreamy&width=600&height=800&seq=comic-cover-03&orientation=portrait',
    category: '恋爱',
    status: '连载中',
    description: '根据古典小说记载，世上有人有妖，妖会与人相恋，妖寿命千万年，人的寿命有限，人死了，妖活着。人会投胎转世，但投胎以后，不记得上辈子的爱。妖如果痴情的话，就去找狐妖"购买"一项服务，让投胎转世的人回忆起前世的爱。',
    rating: 9.3,
    views: 8700000,
    chapters: 485,
    updatedAt: '2026-08-05',
    tags: ['恋爱', '奇幻', '古风'],
  },
  {
    id: 'quan-zhi-gao-shou',
    title: '全职高手',
    author: '蝴蝶蓝',
    cover: 'https://readdy.ai/api/search-image?query=Professional%20esports%20player%20in%20gaming%20gear%20with%20intense%20focused%20expression%2C%20cyberpunk%20background%20with%20glowing%20screens%2C%20anime%20style%20action%20cover%20art%2C%20cool%20blue%20and%20neon%20color%20scheme&width=600&height=800&seq=comic-cover-04&orientation=portrait',
    category: '热血',
    status: '已完结',
    description: '网游荣耀中被誉为教科书级别的顶尖高手叶修，因为种种原因遭到俱乐部的驱逐，离开职业圈的他栖身于一家网吧成了一个小小的网管，但是，拥有十年游戏经验的他，在荣耀新开的第十区重新投入了游戏，带着对往昔的回忆，和一把未完成的自制武器，开始了重返巅峰之路。',
    rating: 9.7,
    views: 15600000,
    chapters: 420,
    updatedAt: '2026-08-04',
    tags: ['游戏', '热血', '竞技'],
  },
  {
    id: 'shi-luo-de-kong-jian',
    title: '尸兄',
    author: '七度鱼',
    cover: 'https://readdy.ai/api/search-image?query=Zombie%20apocalypse%20survival%20scene%20with%20determined%20young%20man%20wielding%20makeshift%20weapon%2C%20dark%20urban%20setting%20with%20red%20moon%2C%20anime%20horror%20comedy%20style%2C%20tense%20but%20slightly%20humorous%20atmosphere&width=600&height=800&seq=comic-cover-05&orientation=portrait',
    category: '搞笑',
    status: '连载中',
    description: '两个盗墓贼用货车盗走了一个棺材，在棺材中藏着一只尸王。半路上棺椁从车厢里掉进H市的自来水厂，使得整个H市的自来水被污染，喝了被污染的水的人都会变成"尸兄"，H市顿时陷入了一片混乱之中。主角白小飞为了找到女友小薇，踏上了一条充满危机的求生之路。',
    rating: 8.9,
    views: 7200000,
    chapters: 380,
    updatedAt: '2026-08-06',
    tags: ['搞笑', '恐怖', '生存'],
  },
  {
    id: 'zhen-hun-jie',
    title: '镇魂街',
    author: '许辰',
    cover: 'https://readdy.ai/api/search-image?query=Guardian%20spirit%20warrior%20in%20ancient%20Chinese%20armor%20standing%20in%20mystical%20spirit%20realm%2C%20epic%20fantasy%20atmosphere%20with%20floating%20lanterns%2C%20anime%20style%20illustration%20with%20golden%20and%20dark%20blue%20color%20scheme&width=600&height=800&seq=comic-cover-06&orientation=portrait',
    category: '热血',
    status: '连载中',
    description: '普通的应届大学毕业生夏铃在求职之际，收到了一条奇怪的面试通知，误入罗刹街并遭遇危险，幸而被镇魂将曹焱兵搭救。然而接触中，曹焱兵却发现夏铃并非看起来那样普通。',
    rating: 9.4,
    views: 10500000,
    chapters: 530,
    updatedAt: '2026-08-05',
    tags: ['热血', '奇幻', '战斗'],
  },
  {
    id: 'da-wang-rao-ming',
    title: '大王饶命',
    author: '会说话的肘子',
    cover: 'https://readdy.ai/api/search-image?query=Teenage%20boy%20with%20cheeky%20smile%20holding%20a%20mysterious%20glowing%20orb%2C%20modern%20school%20setting%20with%20supernatural%20elements%2C%20anime%20comedy%20style%20with%20bright%20and%20vibrant%20colors%2C%20lighthearted%20and%20fun%20atmosphere&width=600&height=800&seq=comic-cover-07&orientation=portrait',
    category: '搞笑',
    status: '连载中',
    description: '灵气复苏的时代，主角吕树在孤儿院长大，意外获得了通过吸收他人负面情绪来提升修为的能力。为了变强他到处惹是生非，让同学和老师又爱又恨。',
    rating: 9.2,
    views: 8900000,
    chapters: 445,
    updatedAt: '2026-08-06',
    tags: ['搞笑', '都市', '异能'],
  },
  {
    id: 'xing-hai',
    title: '星海',
    author: '番茄',
    cover: 'https://readdy.ai/api/search-image?query=Futuristic%20space%20adventure%20with%20young%20pilot%20in%20sleek%20spacesuit%2C%20vast%20galaxy%20background%20with%20colorful%20nebula%20and%20stars%2C%20sci-fi%20anime%20style%20with%20purple%20and%20deep%20blue%20tones%2C%20epic%20and%20wondrous%20atmosphere&width=600&height=800&seq=comic-cover-08&orientation=portrait',
    category: '科幻',
    status: '连载中',
    chapters: 320,
    views: 6500000,
    rating: 9.0,
    description: '在遥远的未来，人类已经进入星际时代。少年星尘偶然获得了一艘神秘的远古飞船，从此踏上了探索宇宙奥秘的旅程，揭开一个又一个隐藏在星海深处的秘密。',
    updatedAt: '2026-08-06',
    tags: ['科幻', '冒险', '宇宙'],
  },
  {
    id: 'mo-dao-zu-shi',
    title: '魔道祖师',
    author: '墨香铜臭',
    cover: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20cultivator%20in%20flowing%20black%20and%20red%20robes%20playing%20a%20guqin%20under%20moonlight%2C%20traditional%20Chinese%20ink%20painting%20style%20blended%20with%20anime%20art%2C%20mysterious%20and%20elegant%20atmosphere%20with%20lotus%20flowers&width=600&height=800&seq=comic-cover-09&orientation=portrait',
    category: '古风',
    status: '已完结',
    chapters: 260,
    views: 13500000,
    rating: 9.8,
    description: '夷陵老祖魏无羡死后十三年，被强行献舍重生，与昔日同窗蓝忘机重逢。两人携手探寻一具被分尸的神秘尸体背后的真相，逐渐揭开了多年前不为人知的秘密。',
    updatedAt: '2026-08-03',
    tags: ['古风', '玄幻', '悬疑'],
  },
  {
    id: 'shi-wan-ge-leng-xiaohua',
    title: '十万个冷笑话',
    author: '寒舞',
    cover: 'https://readdy.ai/api/search-image?query=Chibi%20style%20characters%20in%20hilarious%20exaggerated%20expressions%20and%20poses%2C%20colorful%20and%20chaotic%20background%2C%20anime%20comedy%20style%20with%20bright%20rainbow%20colors%2C%20pure%20fun%20and%20nonsensical%20vibe&width=600&height=800&seq=comic-cover-10&orientation=portrait',
    category: '搞笑',
    status: '连载中',
    chapters: 550,
    views: 18200000,
    rating: 9.1,
    description: '以搞笑吐槽为主的短篇漫画合集，包含了哪吒篇、世界末日篇、超人篇等众多独立故事。脑洞清奇，笑点密集，是解压放松的最佳选择。',
    updatedAt: '2026-08-06',
    tags: ['搞笑', '吐槽', '短篇'],
  },
  {
    id: 'chang-ge-xing',
    title: '长歌行',
    author: '夏达',
    cover: 'https://readdy.ai/api/search-image?query=Elegant%20princess%20in%20traditional%20Tang%20dynasty%20hanfu%20holding%20a%20sword%2C%20historical%20Chinese%20palace%20setting%20with%20peach%20blossoms%2C%20beautiful%20detailed%20anime%20art%20style%20with%20warm%20golden%20and%20peach%20tones&width=600&height=800&seq=comic-cover-11&orientation=portrait',
    category: '古风',
    status: '连载中',
    chapters: 180,
    views: 5600000,
    rating: 9.4,
    description: '玄武门之变后，太子李建成之女李长歌侥幸逃生，踏上复仇之路。她女扮男装，在乱世中历经艰险，最终放下了仇恨，肩负起守护大唐子民的重任。',
    updatedAt: '2026-08-05',
    tags: ['古风', '历史', '女频'],
  },
  {
    id: 'ling-long',
    title: '玲珑',
    author: '第七夜',
    cover: 'https://readdy.ai/api/search-image?query=Mysterious%20girl%20with%20spirit%20powers%20surrounded%20by%20floating%20crystals%20and%20ancient%20ruins%2C%20fantasy%20world%20with%20magical%20creatures%2C%20anime%20adventure%20style%20with%20emerald%20green%20and%20gold%20color%20scheme&width=600&height=800&seq=comic-cover-12&orientation=portrait',
    category: '奇幻',
    status: '连载中',
    chapters: 290,
    views: 4800000,
    rating: 8.8,
    description: '在一个充满灵力的奇幻大陆上，少女玲珑身怀绝世灵力却无法控制。为了寻找身世之谜，她与伙伴们踏上了冒险之旅，逐渐揭开这片大陆隐藏的古老秘密。',
    updatedAt: '2026-08-06',
    tags: ['奇幻', '冒险', '成长'],
  },
];

export const faqList = [
  {
    question: '抖漫网页版需要下载APP吗？',
    answer: '完全不需要！抖漫网页版是纯网页端漫画阅读平台，直接使用浏览器访问即可，无需下载任何APP或插件。支持PC端和手机浏览器，随时随地打开就能看漫画。',
  },
  {
    question: '抖漫网页版是免费的吗？',
    answer: '是的，抖漫网页版目前所有漫画都是完全免费的。我们致力于为广大漫画爱好者提供优质的免费阅读体验，无需付费即可畅享海量正版漫画资源。',
  },
  {
    question: '抖漫网页版支持哪些设备访问？',
    answer: '抖漫网页版支持所有主流设备：PC电脑端（Windows/Mac）、平板（iPad/Android平板）、手机浏览器（iOS Safari/Android Chrome等），您可以在任何有网络的设备上畅快阅读。',
  },
  {
    question: '抖漫网页版的漫画更新速度快吗？',
    answer: '我们的漫画更新速度非常快，热门连载漫画基本与官方同步更新。团队有专人负责追踪各大漫画平台的更新动态，确保读者第一时间看到最新章节。',
  },
  {
    question: '抖漫网页版怎么用？有使用教程吗？',
    answer: '使用非常简单！打开抖漫网页版后，您可以直接在首页浏览推荐漫画，或通过分类页面按类型筛选喜欢的漫画。点击任意漫画封面即可进入详情页开始阅读，支持键盘左右键翻页，阅读体验流畅自然。',
  },
  {
    question: '抖漫网页版的漫画资源丰富吗？',
    answer: '我们的漫画资源非常丰富，涵盖热血、恋爱、悬疑、搞笑、奇幻、科幻、古风、都市等多种类型。目前收录了数千部优质漫画，并且每天都在不断扩充更新中。',
  },
];